export class HypervergeTokenRes {
  errMsg: string;
  token: string;
}

export class KycSearchRequest {
  aadhaarNumber: string;
  appId: string;
  appKey: string;
  appName: string;
  customerName: string;
  customerType: string;
  dob_doi: string;
  drivingLicense: string;
  gender: string;
  kycReferenceNo: string;
  panNumber: string;
  passportNumber: string;
  returnURL: string;
  searchType: string;
  uniqueId: string;
  voterId: string;
  fileFront: any;
	fileBack: any;
	fileNameFront: string;
	fileTypeFront: string;
	fileNameBack: string;
  fileTypeBack: string;
  gstin: string;
}
